import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';
import { UpdateSocialNetworkDTO } from '../../dtos/social-networks/update-social-network.dto';
import { SocialNetwork } from '../../../domain/entities/social-network.entity';

export class UpdateSocialNetworkUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(id: string, data: UpdateSocialNetworkDTO): Promise<SocialNetwork> {
    return this.repository.update(id, data);
  }
}
